import { functions, selectedAdminEnvironment } from "./firebase";

export const getStaffProvisioningEnvironment = (
	environment = selectedAdminEnvironment,
	projectId = functions.app.options.projectId,
) => {
	if (environment?.projectId !== projectId || environment?.firebaseConfig?.projectId !== projectId) return null;
	if (environment.key === "testing" && projectId === "scervmvp-testing") return "Testing";
	if (environment.key === "dev" && projectId === "scervmvp-dev") return "QA";
	if (environment.key === "production" && projectId === "scervmvp") return "Production";
	return null;
};
